var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkToArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_44948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1507_44948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1507_44948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05005 5.24961C3.83338 5.24961 3.65438 5.32028 3.51305 5.46161C3.37105 5.60361 3.30005 5.78294 3.30005 5.99961V8.99961C3.30005 10.3163 3.76272 11.4373 4.68805 12.3626C5.61272 13.2873 6.73338 13.7496 8.05005 13.7496H17.85L14.5 17.0996C14.3667 17.2329 14.3 17.3996 14.3 17.5996C14.3 17.7996 14.375 17.9746 14.525 18.1246C14.675 18.2746 14.85 18.3496 15.05 18.3496C15.25 18.3496 15.425 18.2746 15.575 18.1246L20.0751 13.6246C20.1584 13.5413 20.2211 13.4456 20.2631 13.3376C20.3044 13.2289 20.3251 13.1163 20.3251 12.9996C20.3251 12.8829 20.3044 12.7706 20.2631 12.6626C20.2211 12.5539 20.1584 12.4579 20.0751 12.3746L15.55 7.84961C15.4167 7.71628 15.25 7.64961 15.05 7.64961C14.85 7.64961 14.675 7.72461 14.525 7.87461C14.375 8.02461 14.3 8.19961 14.3 8.39961C14.3 8.59961 14.375 8.77461 14.525 8.92461L17.85 12.2496H8.05005C7.15005 12.2496 6.38338 11.9329 5.75005 11.2996C5.11672 10.6663 4.80005 9.89961 4.80005 8.99961V5.99961C4.80005 5.78294 4.72938 5.60361 4.58805 5.46161C4.44605 5.32028 4.26672 5.24961 4.05005 5.24961Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_44948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkToArrow);
export default __webpack_public_path__ + "static/media/link-to-arrow.ded6ee5e3ba924fc2ca5293d248c9593.svg";
export { ForwardRef as ReactComponent };